export default __webpack_public_path__ + "static/media/IIT KGP.6f9ed77f.png";